import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import throttle from 'lodash/throttle'

export function useStickyHeader(isApp, navHeaderHeightVar = '--nav-header-height') {
    const showStockSticky = ref(false)
    const stockStickySentinel = ref(null)

    const stickyTopCss = computed(() => {
        return `0`
    })
    const stickyTopCssIsNotApp = computed(() => {
        return `calc(${stickyTopCss.value})`
    })

    const getCssVarPx = (name) => {
        const val = getComputedStyle(document.documentElement).getPropertyValue(name)
        if (!val) return 0
        const m = val.trim().match(/([\d.]+)px/)
        return m ? parseFloat(m[1]) : 0
    }

    const onScrollSticky = () => {
        const el = stockStickySentinel.value
        if (!el) {
            showStockSticky.value = false
            return
        }
        const rect = el.getBoundingClientRect()
        const headerH = getCssVarPx(navHeaderHeightVar) || 0
        const threshold = headerH
        showStockSticky.value = rect.top <= threshold
    }

    const onScrollStickyThrottled = throttle(onScrollSticky, 100)

    onMounted(() => {
        window.addEventListener('scroll', onScrollStickyThrottled, { passive: true })
    })

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', onScrollStickyThrottled)
    })

    return {
        showStockSticky,
        stockStickySentinel,
        stickyTopCss,
        stickyTopCssIsNotApp
    }
}
